import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useIntl } from 'react-intl';
import { Group } from '../../apiRtk/be4feApi';
import { ApartmentUserRole } from '../../modules/apartmentAdmin/data';
import { IUser } from '../../modules/user/store';
import AccessGroupsChipList from '../AccessGroupsChipList';
import ChipListWrapper from '../ChipListWrapper';
import RowSection from '../RowSection';
import SetAccessGroupButton from '../SetAccessGroupButton';
import UserIcon from '../UserIcon';
import messages from './messages';

interface IUserAccessGroupsListProps {
  buttonAction: () => void;
  groups: Array<Group>;
  userRole: IUser['role'] | ApartmentUserRole;
}

function UserAccessGroupsList({ buttonAction, groups, userRole }: IUserAccessGroupsListProps) {
  const { formatMessage } = useIntl();

  return (
    <RowSection icon={<UserIcon userRole={userRole} />} label={formatMessage(messages.userAccessGroupsListLabel)}>
      <Stack
        direction={{ sm: 'row', xs: 'column' }}
        sx={{ justifyContent: { sm: 'space-between', xs: 'flex-start' }, width: 'inherit' }}
      >
        <Box>
          <ChipListWrapper emptyPlaceholder={formatMessage(messages.userAccessGroupsListEmpty)}>
            {groups.length ? <AccessGroupsChipList groups={groups} /> : null}
          </ChipListWrapper>
        </Box>
        <Box>
          <SetAccessGroupButton onClick={buttonAction} />
        </Box>
      </Stack>
    </RowSection>
  );
}

export default UserAccessGroupsList;
